import React from "react";

const NeueQuoteRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.3999 3.90578C2.3999 3.07411 3.06114 2.3999 3.87683 2.3999H5.72298C6.53868 2.3999 7.1999 3.07411 7.1999 3.90578V5.5521C7.1999 6.18253 6.94151 6.78428 6.48714 7.21187L4.7999 8.7999V6.54108H3.87683C3.06114 6.54108 2.3999 5.86687 2.3999 5.0352V3.90578Z",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.80005 8.70608C8.80005 7.87438 9.46127 7.2002 10.277 7.2002H12.1231C12.9388 7.2002 13.6 7.87438 13.6 8.70608V10.3524C13.6 10.9828 13.3417 11.5846 12.8873 12.0122L11.2 13.6002V11.3414H10.277C9.46127 11.3414 8.80005 10.6672 8.80005 9.83549V8.70608Z",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(NeueQuoteRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;